module.exports = __webpack_public_path__ + "static/media/logoLight.a43785cd.webp";